/**
 * Shared icon SVGs used across game stages — VaultGlyph for "safe" reveals,
 * AlarmBell for "mine triggered" reveals. Hoisted from pressure-plate/core.tsx
 * so a third game can import the same shapes without duplication.
 */

export function VaultGlyph({
  size = 24,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-12 -12 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M0 -8 L7 -5 L7 3 Q7 7 0 9 Q-7 7 -7 3 L-7 -5 Z" />
      <circle cx="0" cy="-1" r="2.5" fill={color} opacity="0.2" />
      <circle cx="0" cy="-1" r="1.2" fill={color} />
      <line x1="0" y1="0.3" x2="0" y2="4" />
    </svg>
  );
}

export function AlarmBell({
  size = 24,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-12 -12 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M-6 4 Q-6 -6 0 -8 Q6 -6 6 4 L7.5 5.5 L-7.5 5.5 Z"
        fill={color}
        fillOpacity="0.15"
      />
      <line x1="-2" y1="7.5" x2="2" y2="7.5" />
      <circle cx="0" cy="-9.5" r="1" />
      <line x1="0" y1="-1" x2="0" y2="3" />
      <line x1="-2" y1="1" x2="2" y2="1" />
    </svg>
  );
}
